import { Component, OnInit } from '@angular/core';
import { Cxcdetregcomp } from '../cxcinterfaces/cxcdetregcomp';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { Cxcdetregcomptmp } from "../cxcinterfaces/cxcdetregcomptmp";
import { CxcdetcomprobanteService } from "../cxcservicios/cxcdetcomprobante.service";
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { DatePipe } from '@angular/common';
import { ConfirmationService, MessageService, SelectItem } from 'primeng';
import { isNullOrUndefined } from 'util';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { CxcregcomprobanteService } from "../cxcservicios/cxcregcomprobante.service";
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';

@Component({
  selector: 'app-cxcdetcomprobante',
  templateUrl: './cxcdetcomprobante.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class CxcdetcomprobanteComponent implements OnInit {

  indicador: any;
  permisoRegcomp: SegMaePermiso;
  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;
  public frameworkComponents;
  rowSelection = 'multiple';
  defaultCxcdetcomp;
  rowStyle;
  largo: string;
  detcompSelected: Cxcdetregcomp;
  index = 0;

  types: SelectItem[];
  busquedacampos: any[];
  tabla: string;
  consulta: string;
  arregloCons: any[];
  arregloBus: any[];
  condicion: string;
  opcion: string;
  displayDialogBusquedaFast: boolean;
  displayDialogBusqueda: boolean;
  BAN_CODIGO
  where: string
  lblbannombre
  columnDefsDetcomprobante = [
    {
      headerName: 'Número', field: 'ENCREGCOMPRO_NUMERO', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Emisión', field: 'ENCREGCOMPRO_FECHA',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 89, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        //this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Fecha', field: 'DETREGCOMPRO_FECHA',
      editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 89, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        //this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Referencia', field: 'DETREGCOMPRO_REFERENCIA', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Comprobante', field: 'DETREGCOMPRO_COMPROBANTE', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 120, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Concepto', field: 'DETREGCOMPRO_CONCEPTO', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Importe', field: 'DETREGCOMPRO_IMPORTE', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 95, cellStyle: { textAlign: 'right' },
      onCellDoubleClicked: (params) => {
        ///this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Cliente', field: 'CLI_CODIGO', editable: (params) => {
        return this.validaciboolena(params)
      }, cellEditor: 'cellPrueba', width: 95,
      cellStyle: { textAlign: 'left' },
      cellEditorParams:
      {

        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 20,
          opcionbuscar: true
        }

      }
    },
    {
      headerName: 'Nombre', field: 'CLI_NOMBRE', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    },
    {
      headerName: 'Referencia', field: 'DETREGCOMPRO_REFERENCIA2', editable: (params) => {
        return this.validaciboolena(params)
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 100
        }
      }
    },
    {
      headerName: 'CI', field: 'TRNCOBRO_NRODOC', editable: (params) => {
        return false;
      }, cellEditor: 'cellPrueba', width: 200, cellStyle: { textAlign: 'left' },
      onCellDoubleClicked: (params) => {
        // this.abrirBanTrnBanEdit(params.data);
      }
    }
  ];
  constructor(public cxcdetcomprobanteService: CxcdetcomprobanteService, public cxcregcomprobanteService: CxcregcomprobanteService,
    private busquedaSer: InvbusquedaService,
    public init: NuevoComponentService, private datePipe: DatePipe, private messageService: MessageService, private auditoriagral: AuditoriagralService, ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    // this.rowStyle = (params) => {
    //   if (params.data.COLOREXISTEDOC === 'Y') {
    //     return { background: 'rgb(245,236,166)' };
    //   }
    // };
    this.defaultCxcdetcomp = {
      editable: true,
      objeto: 'cxcdetcomp',
      resizable: true
    };
  }


  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.botonNuevo = true;
    this.botonGuardar = true;
    this.botonBorrar = true;
    this.botonRegresar = true;
    this.BAN_CODIGO = '';
    try {
      this.cxcdetcomprobanteService.detregcomp = []
      const data = await this.cxcdetcomprobanteService.getdetregcomprobante()
      if (data !== null) {
        for (const item of data) {
          if (item.DETREGCOMPRO_FECHA.toString().includes('-')) {
            item.DETREGCOMPRO_FECHA = this.datePipe.transform(item.DETREGCOMPRO_FECHA, 'dd/MM/yyyy')
          }
          if (item.ENCREGCOMPRO_FECHA.toString().includes('-')) {
            item.ENCREGCOMPRO_FECHA = this.datePipe.transform(item.ENCREGCOMPRO_FECHA, 'dd/MM/yyyy')
          }
          item.DETREGCOMPRO_IMPORTE = Number(item.DETREGCOMPRO_IMPORTE).toFixed(2)
        }
        this.cxcdetcomprobanteService.detregcomp = data
      }
    } catch (error) {
      this.messageService.add({
        key: 'cxcdetcom',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al cargar la información' + error
      });
    }
  }
  changeTabs() {

  }
  manejarSenales(valor) {

    if (valor === 'Guardar') {
      this.guardar()
    }
    if (valor === 'Cancelar') {
      this.cancelar()
    }
    if (valor === 'Buscar') {
      this.buscarRegistro()
    }
    if (valor === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }
  }
  setFocus(event) {
    let element: any;
    switch (event.target.id) {
      case 'BAN_CODIGO': {
        this.busquedabanco(event.target.value);
        break;
      }
      default: {
        break;
      }
    }
  }
  buscarRegistro() {
    this.opcion = 'BUSCAR';
    this.types = [
      { label: 'NÚMERO', value: 'ENCREGCOMPRO_NUMERO' },
      { label: 'Fecha', value: 'DETREGCOMPRO_FECHA' },
      { label: 'Comprobante', value: 'DETREGCOMPRO_COMPROBANTE' },
      { label: 'Cod. Cliente', value: 'CLI_CODIGO' },
      { label: 'Nom. Cliente', value: 'CLI_NOMBRE' }

    ];

    this.busquedacampos = ['', '', '', '', ''];
    this.consulta = ' b.*,a.ENCREGCOMPRO_FECHA, NVL(VEN_FNC_NOMBRE_CLIENTE(b.CLI_CODIGO,\'01\'),\'\') AS CLI_NOMBRE ';
    this.tabla = 'cxc_encregcompro a, cxc_detregcompro b';
    this.condicion = ' a.ENCREGCOMPRO_NUMERO = b.ENCREGCOMPRO_NUMERO'
    this.condicion += ' and a.COM_CODIGO = b.COM_CODIGO '
    this.condicion += ' AND B.COM_CODIGO=\'01\''
    this.where = ''
    this.displayDialogBusquedaFast = true;
  }
  busquedabanco(parametro) {
    this.opcion = 'BuscarBanco';
    this.types = [
      { label: 'CÓDIGO', value: 'BAN_CODIGO' },
      { label: 'BANCO', value: 'BAN_BANCO' },
      { label: 'CUENTA NRO', value: 'BAN_CTANRO' },

    ];

    this.busquedacampos = [parametro, '', ''];
    this.consulta = 'BAN_codigo,BAN_banco, NVL(BAN_ctanro, \'*\') AS BAN_CTANRO'
    this.tabla = 'BAN_MAEBAN';
    this.where = '';

    this.cxcregcomprobanteService.encontrarBanco(this.types[0].value + ' LIKE \'' + parametro + '\'').subscribe(eR => {
      if (eR !== null) {
        if (eR[0] !== undefined) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.busquedaSer.busquedaBanMaeBan2(parametro).subscribe((res: any[]) => {
            this.arregloCons = res;
            this.displayDialogBusqueda = true;
          });
        }
      } else {
        this.busquedaSer.busquedaBanMaeBan2(parametro).subscribe((res: any[]) => {
          this.arregloCons = res;
          this.displayDialogBusqueda = true;
        });
      }
    });
  }
  manejarSeleccion(valor) {
    if (this.opcion === 'BUSCAR') {
      this.displayDialogBusquedaFast = false;
      this.llenarTabla(valor);
    }
    if (this.opcion === 'BuscarBanco') {
      this.BAN_CODIGO = valor.BAN_CODIGO
      this.lblbannombre = valor.BAN_BANCO
      this.displayDialogBusqueda = false
    }
  }
  async llenarTabla(data) {
    if (data !== null) {
      //console.log(data)
      this.cxcdetcomprobanteService.detregcomp = []
      for (const item of data) {
        if (item.DETREGCOMPRO_FECHA.toString().includes('-')) {
          item.DETREGCOMPRO_FECHA = this.datePipe.transform(item.DETREGCOMPRO_FECHA, 'dd/MM/yyyy')
        }
        if (item.ENCREGCOMPRO_FECHA.toString().includes('-')) {
          item.ENCREGCOMPRO_FECHA = this.datePipe.transform(item.ENCREGCOMPRO_FECHA, 'dd/MM/yyyy')
        }
        item.DETREGCOMPRO_IMPORTE = Number(item.DETREGCOMPRO_IMPORTE).toFixed(2)
      }
      this.cxcdetcomprobanteService.detregcomp = data
    }
  }
  async aceptar() {
    try {
      const data = await this.cxcdetcomprobanteService.getdetregcomprobanteban(this.BAN_CODIGO)
      if (data !== null) {
        this.cxcdetcomprobanteService.detregcomp = []
        for (const item of data) {
          if (item.DETREGCOMPRO_FECHA.toString().includes('-')) {
            item.DETREGCOMPRO_FECHA = this.datePipe.transform(item.DETREGCOMPRO_FECHA, 'dd/MM/yyyy')
          }
          if (item.ENCREGCOMPRO_FECHA.toString().includes('-')) {
            item.ENCREGCOMPRO_FECHA = this.datePipe.transform(item.ENCREGCOMPRO_FECHA, 'dd/MM/yyyy')
          }
          item.DETREGCOMPRO_IMPORTE = Number(item.DETREGCOMPRO_IMPORTE).toFixed(2)
        }
        this.cxcdetcomprobanteService.detregcomp = data
      }
    } catch (error) {
      this.messageService.add({
        key: 'cxcdetcom',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar la información'
      });
      return
    }
  }
  async guardar() {
    try {
      if (isNullOrUndefined(this.detcompSelected) || this.detcompSelected === '' || Object.keys(this.detcompSelected).length === 0) {
        this.messageService.add({
          key: 'cxcdetcom',
          severity: 'error',
          summary: 'Información',
          detail: 'No se ha seleccionado ningún registro'
        });
        return
      }
      await this.cxcdetcomprobanteService.actualizarregistrodet(this.detcompSelected)
      await this.auditoriagral.registrarAuditoria('CXC_DETREGCOMPRO',
        this.detcompSelected.ENCREGCOMPRO_NUMERO + '/' + this.detcompSelected.BAN_CODIGO + '/' + this.detcompSelected.DETREGCOMPRO_COMPROBANTE +'/'+ this.detcompSelected.CLI_CODIGO, 'A',
        '', '01', '', '', '', '').toPromise();
      this.messageService.add({
        key: 'cxcdetcom',
        severity: 'success',
        summary: 'Información',
        detail: 'Éxito al guardar '
      });
      this.botonNuevo = true;
      this.botonGuardar = true;
      this.botonBorrar = true;
      this.botonRegresar = true;
    } catch (error) {
      this.messageService.add({
        key: 'cxcdetcom',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al guardar la información' + error
      });
    }
  }
  async cancelar() {
    try {
      this.botonNuevo = true;
      this.botonGuardar = true;
      this.botonBorrar = true;
      this.botonRegresar = true;
      this.BAN_CODIGO = '';
      this.lblbannombre = '';
      this.cxcdetcomprobanteService.detregcomp = []
      const data = await this.cxcdetcomprobanteService.getdetregcomprobante()
      if (data !== null) {
        for (const item of data) {
          if (item.DETREGCOMPRO_FECHA.toString().includes('-')) {
            item.DETREGCOMPRO_FECHA = this.datePipe.transform(item.DETREGCOMPRO_FECHA, 'dd/MM/yyyy')
          }
          if (item.ENCREGCOMPRO_FECHA.toString().includes('-')) {
            item.ENCREGCOMPRO_FECHA = this.datePipe.transform(item.ENCREGCOMPRO_FECHA, 'dd/MM/yyyy')
          }
          item.DETREGCOMPRO_IMPORTE = Number(item.DETREGCOMPRO_IMPORTE).toFixed(2)
        }
        this.cxcdetcomprobanteService.detregcomp = data
      }
    } catch (error) {
      this.messageService.add({
        key: 'cxcdetcom',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al cargar la información' + error
      });
    }
  }
  cambio(evento) {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
  }
  seleccionItem(params) {
    if (params.object !== undefined) {

      this.detcompSelected = params.object;
    }
  }
  validaciboolena(params){
    if(params.data.TRNCOBRO_NRODOC === '' || isNullOrUndefined (params.data.TRNCOBRO_NRODOC)){
    return true
    }else{
      this.botonNuevo = false;
      this.botonGuardar = true;
      this.botonBorrar = true;
      this.botonRegresar = false;
      return false
    }
  }
}
